/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Infra API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseInfraHostInfoItem,
  ApiResponseResponseWithColumnInfraHostItemV8,
  GetV8InfraHostsParams,
  HostProcessRequestBody,
  InfraContainerV8Response,
  InfraHostConfigResponse,
  InfraHostGpuInfoResponse,
  InfraHostGpuV8Response,
  InfraHostNpmEnabledResponse,
  InfraHostProcessInfoResponse,
  InfraHostTopProcessResponse,
  InfraHostsProcessV8Response,
  PostV8InfraHostsTopProcessParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getHostList
 */
export const getV8InfraHosts = (
  params?: MaybeRef<GetV8InfraHostsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseResponseWithColumnInfraHostItemV8>(
    { url: `/api/v8/infra/hosts`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8InfraHostsQueryKey = (params?: MaybeRef<GetV8InfraHostsParams>) => {
  return ['api', 'v8', 'infra', 'hosts', ...(params ? [params] : [])] as const;
};

export const getGetV8InfraHostsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8InfraHosts>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8InfraHostsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHosts>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8InfraHostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8InfraHosts>>> = ({ signal }) =>
    getV8InfraHosts(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8InfraHosts>>,
    TError,
    TData
  >;
};

export type GetV8InfraHostsQueryResult = NonNullable<Awaited<ReturnType<typeof getV8InfraHosts>>>;
export type GetV8InfraHostsQueryError = ErrorType<unknown>;

/**
 * @summary getHostList
 */

export function useGetV8InfraHosts<
  TData = Awaited<ReturnType<typeof getV8InfraHosts>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8InfraHostsParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHosts>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8InfraHostsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 호스트 Config 설정 값 조회
 */
export const getV8InfraHostsConfig = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<InfraHostConfigResponse>(
    { url: `/api/v8/infra/hosts/config`, method: 'GET', signal },
    options,
  );
};

export const getGetV8InfraHostsConfigQueryKey = () => {
  return ['api', 'v8', 'infra', 'hosts', 'config'] as const;
};

export const getGetV8InfraHostsConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8InfraHostsConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsConfig>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8InfraHostsConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8InfraHostsConfig>>> = ({ signal }) =>
    getV8InfraHostsConfig(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8InfraHostsConfig>>,
    TError,
    TData
  >;
};

export type GetV8InfraHostsConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8InfraHostsConfig>>
>;
export type GetV8InfraHostsConfigQueryError = ErrorType<unknown>;

/**
 * @summary 호스트 Config 설정 값 조회
 */

export function useGetV8InfraHostsConfig<
  TData = Awaited<ReturnType<typeof getV8InfraHostsConfig>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsConfig>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8InfraHostsConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 네트워크 오브젝트 대상 설정 가능한(npm_enabled) 호스트 리스트
 */
export const getV8InfraHostsNpmEnabled = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<InfraHostNpmEnabledResponse>(
    { url: `/api/v8/infra/hosts/npm-enabled`, method: 'GET', signal },
    options,
  );
};

export const getGetV8InfraHostsNpmEnabledQueryKey = () => {
  return ['api', 'v8', 'infra', 'hosts', 'npm-enabled'] as const;
};

export const getGetV8InfraHostsNpmEnabledQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8InfraHostsNpmEnabled>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsNpmEnabled>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8InfraHostsNpmEnabledQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8InfraHostsNpmEnabled>>> = ({
    signal,
  }) => getV8InfraHostsNpmEnabled(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8InfraHostsNpmEnabled>>,
    TError,
    TData
  >;
};

export type GetV8InfraHostsNpmEnabledQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8InfraHostsNpmEnabled>>
>;
export type GetV8InfraHostsNpmEnabledQueryError = ErrorType<unknown>;

/**
 * @summary 네트워크 오브젝트 대상 설정 가능한(npm_enabled) 호스트 리스트
 */

export function useGetV8InfraHostsNpmEnabled<
  TData = Awaited<ReturnType<typeof getV8InfraHostsNpmEnabled>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsNpmEnabled>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8InfraHostsNpmEnabledQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 다중 호스트 프로세스 조회 (분석 연계)
 * @summary 다중 호스트 프로세스 조회 (분석 연계)
 */
export const postV8InfraHostsProcess = (
  hostProcessRequestBody: MaybeRef<HostProcessRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostProcessRequestBody = unref(hostProcessRequestBody);

  return customAxiosInstance<InfraHostsProcessV8Response>(
    {
      url: `/api/v8/infra/hosts/process`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: hostProcessRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV8InfraHostsProcessMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8InfraHostsProcess>>,
    TError,
    { data: BodyType<HostProcessRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8InfraHostsProcess>>,
  TError,
  { data: BodyType<HostProcessRequestBody> },
  TContext
> => {
  const mutationKey = ['postV8InfraHostsProcess'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8InfraHostsProcess>>,
    { data: BodyType<HostProcessRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV8InfraHostsProcess(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8InfraHostsProcessMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8InfraHostsProcess>>
>;
export type PostV8InfraHostsProcessMutationBody = BodyType<HostProcessRequestBody>;
export type PostV8InfraHostsProcessMutationError = ErrorType<unknown>;

/**
 * @summary 다중 호스트 프로세스 조회 (분석 연계)
 */
export const usePostV8InfraHostsProcess = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8InfraHostsProcess>>,
      TError,
      { data: BodyType<HostProcessRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8InfraHostsProcess>>,
  TError,
  { data: BodyType<HostProcessRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV8InfraHostsProcessMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Top 프로세스 조회 (분석 연계)
 * @summary Top 프로세스 조회 (분석 연계)
 */
export const postV8InfraHostsTopProcess = (
  hostProcessRequestBody: MaybeRef<HostProcessRequestBody>,
  params?: MaybeRef<PostV8InfraHostsTopProcessParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostProcessRequestBody = unref(hostProcessRequestBody);
  params = unref(params);

  return customAxiosInstance<InfraHostTopProcessResponse>(
    {
      url: `/api/v8/infra/hosts/top-process`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: hostProcessRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV8InfraHostsTopProcessMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV8InfraHostsTopProcess>>,
    TError,
    { data: BodyType<HostProcessRequestBody>; params?: PostV8InfraHostsTopProcessParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV8InfraHostsTopProcess>>,
  TError,
  { data: BodyType<HostProcessRequestBody>; params?: PostV8InfraHostsTopProcessParams },
  TContext
> => {
  const mutationKey = ['postV8InfraHostsTopProcess'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV8InfraHostsTopProcess>>,
    { data: BodyType<HostProcessRequestBody>; params?: PostV8InfraHostsTopProcessParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV8InfraHostsTopProcess(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV8InfraHostsTopProcessMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV8InfraHostsTopProcess>>
>;
export type PostV8InfraHostsTopProcessMutationBody = BodyType<HostProcessRequestBody>;
export type PostV8InfraHostsTopProcessMutationError = ErrorType<unknown>;

/**
 * @summary Top 프로세스 조회 (분석 연계)
 */
export const usePostV8InfraHostsTopProcess = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV8InfraHostsTopProcess>>,
      TError,
      { data: BodyType<HostProcessRequestBody>; params?: PostV8InfraHostsTopProcessParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV8InfraHostsTopProcess>>,
  TError,
  { data: BodyType<HostProcessRequestBody>; params?: PostV8InfraHostsTopProcessParams },
  TContext
> => {
  const mutationOptions = getPostV8InfraHostsTopProcessMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 호스트에 속한 컨테이너 목록을 조회
 * @summary 호스트 컨테이너 목록 조회
 */
export const getV8InfraHostsContainersByHostId = (
  hostId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);

  return customAxiosInstance<InfraContainerV8Response>(
    { url: `/api/v8/infra/hosts/${hostId}/containers`, method: 'GET', signal },
    options,
  );
};

export const getGetV8InfraHostsContainersByHostIdQueryKey = (hostId?: MaybeRef<string>) => {
  return ['api', 'v8', 'infra', 'hosts', hostId, 'containers'] as const;
};

export const getGetV8InfraHostsContainersByHostIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8InfraHostsContainersByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsContainersByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8InfraHostsContainersByHostIdQueryKey(hostId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8InfraHostsContainersByHostId>>> = ({
    signal,
  }) => getV8InfraHostsContainersByHostId(hostId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(hostId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8InfraHostsContainersByHostId>>,
    TError,
    TData
  >;
};

export type GetV8InfraHostsContainersByHostIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8InfraHostsContainersByHostId>>
>;
export type GetV8InfraHostsContainersByHostIdQueryError = ErrorType<unknown>;

/**
 * @summary 호스트 컨테이너 목록 조회
 */

export function useGetV8InfraHostsContainersByHostId<
  TData = Awaited<ReturnType<typeof getV8InfraHostsContainersByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsContainersByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8InfraHostsContainersByHostIdQueryOptions(hostId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Host Gpu 리스트
 */
export const getV8InfraHostsGpuByHostId = (
  hostId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);

  return customAxiosInstance<InfraHostGpuV8Response>(
    { url: `/api/v8/infra/hosts/${hostId}/gpu`, method: 'GET', signal },
    options,
  );
};

export const getGetV8InfraHostsGpuByHostIdQueryKey = (hostId?: MaybeRef<string>) => {
  return ['api', 'v8', 'infra', 'hosts', hostId, 'gpu'] as const;
};

export const getGetV8InfraHostsGpuByHostIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8InfraHostsGpuByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsGpuByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8InfraHostsGpuByHostIdQueryKey(hostId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8InfraHostsGpuByHostId>>> = ({
    signal,
  }) => getV8InfraHostsGpuByHostId(hostId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(hostId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsGpuByHostId>>, TError, TData>;
};

export type GetV8InfraHostsGpuByHostIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8InfraHostsGpuByHostId>>
>;
export type GetV8InfraHostsGpuByHostIdQueryError = ErrorType<unknown>;

/**
 * @summary Host Gpu 리스트
 */

export function useGetV8InfraHostsGpuByHostId<
  TData = Awaited<ReturnType<typeof getV8InfraHostsGpuByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsGpuByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8InfraHostsGpuByHostIdQueryOptions(hostId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Host GPU 상세 정보
 */
export const getV8InfraHostsGpusByHostIdAndGpuUid = (
  hostId: MaybeRef<string>,
  gpuUid: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);
  gpuUid = unref(gpuUid);

  return customAxiosInstance<InfraHostGpuInfoResponse>(
    { url: `/api/v8/infra/hosts/${hostId}/gpus/${gpuUid}`, method: 'GET', signal },
    options,
  );
};

export const getGetV8InfraHostsGpusByHostIdAndGpuUidQueryKey = (
  hostId?: MaybeRef<string>,
  gpuUid?: MaybeRef<string>,
) => {
  return ['api', 'v8', 'infra', 'hosts', hostId, 'gpus', gpuUid] as const;
};

export const getGetV8InfraHostsGpusByHostIdAndGpuUidQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8InfraHostsGpusByHostIdAndGpuUid>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  gpuUid: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8InfraHostsGpusByHostIdAndGpuUid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8InfraHostsGpusByHostIdAndGpuUidQueryKey(hostId, gpuUid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8InfraHostsGpusByHostIdAndGpuUid>>
  > = ({ signal }) => getV8InfraHostsGpusByHostIdAndGpuUid(hostId, gpuUid, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(hostId) && unref(gpuUid))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8InfraHostsGpusByHostIdAndGpuUid>>,
    TError,
    TData
  >;
};

export type GetV8InfraHostsGpusByHostIdAndGpuUidQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8InfraHostsGpusByHostIdAndGpuUid>>
>;
export type GetV8InfraHostsGpusByHostIdAndGpuUidQueryError = ErrorType<unknown>;

/**
 * @summary Host GPU 상세 정보
 */

export function useGetV8InfraHostsGpusByHostIdAndGpuUid<
  TData = Awaited<ReturnType<typeof getV8InfraHostsGpusByHostIdAndGpuUid>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  gpuUid: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8InfraHostsGpusByHostIdAndGpuUid>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8InfraHostsGpusByHostIdAndGpuUidQueryOptions(hostId, gpuUid, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getHostInfo
 */
export const getV8InfraHostsInfoByHostId = (
  hostId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);

  return customAxiosInstance<ApiResponseInfraHostInfoItem>(
    { url: `/api/v8/infra/hosts/${hostId}/info`, method: 'GET', signal },
    options,
  );
};

export const getGetV8InfraHostsInfoByHostIdQueryKey = (hostId?: MaybeRef<string>) => {
  return ['api', 'v8', 'infra', 'hosts', hostId, 'info'] as const;
};

export const getGetV8InfraHostsInfoByHostIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8InfraHostsInfoByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsInfoByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8InfraHostsInfoByHostIdQueryKey(hostId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8InfraHostsInfoByHostId>>> = ({
    signal,
  }) => getV8InfraHostsInfoByHostId(hostId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(hostId)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsInfoByHostId>>, TError, TData>;
};

export type GetV8InfraHostsInfoByHostIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8InfraHostsInfoByHostId>>
>;
export type GetV8InfraHostsInfoByHostIdQueryError = ErrorType<unknown>;

/**
 * @summary getHostInfo
 */

export function useGetV8InfraHostsInfoByHostId<
  TData = Awaited<ReturnType<typeof getV8InfraHostsInfoByHostId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8InfraHostsInfoByHostId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8InfraHostsInfoByHostIdQueryOptions(hostId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getProcessInfo
 */
export const getV8InfraHostsProcessByHostIdAndProcessId = (
  hostId: MaybeRef<string>,
  processId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  hostId = unref(hostId);
  processId = unref(processId);

  return customAxiosInstance<InfraHostProcessInfoResponse>(
    { url: `/api/v8/infra/hosts/${hostId}/process/${processId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV8InfraHostsProcessByHostIdAndProcessIdQueryKey = (
  hostId?: MaybeRef<string>,
  processId?: MaybeRef<number>,
) => {
  return ['api', 'v8', 'infra', 'hosts', hostId, 'process', processId] as const;
};

export const getGetV8InfraHostsProcessByHostIdAndProcessIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8InfraHostsProcessByHostIdAndProcessId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  processId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8InfraHostsProcessByHostIdAndProcessId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8InfraHostsProcessByHostIdAndProcessIdQueryKey(hostId, processId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8InfraHostsProcessByHostIdAndProcessId>>
  > = ({ signal }) =>
    getV8InfraHostsProcessByHostIdAndProcessId(hostId, processId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(hostId) && unref(processId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8InfraHostsProcessByHostIdAndProcessId>>,
    TError,
    TData
  >;
};

export type GetV8InfraHostsProcessByHostIdAndProcessIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8InfraHostsProcessByHostIdAndProcessId>>
>;
export type GetV8InfraHostsProcessByHostIdAndProcessIdQueryError = ErrorType<unknown>;

/**
 * @summary getProcessInfo
 */

export function useGetV8InfraHostsProcessByHostIdAndProcessId<
  TData = Awaited<ReturnType<typeof getV8InfraHostsProcessByHostIdAndProcessId>>,
  TError = ErrorType<unknown>,
>(
  hostId: MaybeRef<string>,
  processId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8InfraHostsProcessByHostIdAndProcessId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8InfraHostsProcessByHostIdAndProcessIdQueryOptions(
    hostId,
    processId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
